import { createLogger } from '@svenskaspelab/nova-core/log';
import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { formatIssue } from '../utils/entry.js';
import { drawTransformSchema } from './Draw.js';

type FlattenedDraw = z.infer<typeof drawTransformSchema>;

const logger = createLogger('poolbetting.schema');

const delayed = (cb: () => void): unknown => {
  if (typeof globalThis.setImmediate === 'function') {
    return globalThis.setImmediate(cb);
  }

  if (typeof globalThis.requestIdleCallback === 'function') {
    return globalThis.requestIdleCallback(cb);
  }

  return setTimeout(cb, 0);
};

export const drawsResponseTransformSchema = z
  .object({
    draws: z.unknown(),
  })
  .transform(({ draws }) => ({
    data: Array.isArray(draws)
      ? draws
          .map((item) => drawTransformSchema.safeParse(item))
          .filter((drawResponse, index): drawResponse is z.ZodSafeParseSuccess<FlattenedDraw> => {
            if (drawResponse.error) {
              delayed(() => {
                logger.warn(
                  `Unable to parse draw(${index}): ${JSON.stringify(drawResponse.error.issues.map((issue) => formatIssue(issue)))}`
                );
              });
            }

            return drawResponse.success;
          })
          .map((r) => r.data)
      : [],
  }));

export const drawsApiResponse = {
  parse: (data: unknown) => z.union([apiErrorSchema, drawsResponseTransformSchema]).parse(data),
} as const;
